import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * El germà de MultilingualTextInput per als textos llargs. Mateixa regla:
 * s'escriu en l'idioma de la interfície i l'altre és un camp plegat. El perquè
 * és a MultilingualTextInput.
 */
function MultilingualTextArea({
  value = {},
  onChange,
  label,
  placeholder = {},
  required = false,
  rows = 4,
  maxLength = null,
  className = ""
}) {
  const { t, i18n } = useTranslation();

  // Mateixa xarxa de seguretat que a MultilingualTextInput: si arriba una
  // cadena, escampar-la amb ...value la trencaria en caràcters indexats.
  const segur = value && typeof value === 'object' && !Array.isArray(value) ? value : {};

  const idioma = (i18n.language || '').startsWith('en') ? 'en' : 'ca';
  const altre = idioma === 'en' ? 'ca' : 'en';
  const nomAltre = t(`multilingual.${altre === 'en' ? 'english' : 'catalan'}`);

  const teAltre = Boolean((segur[altre] || '').trim());
  const [obert, setObert] = useState(false);
  useEffect(() => {
    if (teAltre) setObert(true);
  }, [teAltre]);

  const escriu = (lang, nou) => onChange({ ...segur, [lang]: nou });

  return (
    <div className={`camp-idioma ${className}`}>
      <label className="camp-idioma-etiqueta">
        {label} {required && <span className="required">*</span>}
      </label>

      <textarea
        value={segur[idioma] || ''}
        onChange={(e) => escriu(idioma, e.target.value)}
        placeholder={placeholder[idioma] || ''}
        rows={rows}
        maxLength={maxLength}
        required={required}
        className="camp-idioma-camp"
      />
      {maxLength && (
        <div className="char-count">{(segur[idioma] || '').length}/{maxLength}</div>
      )}

      <details className="camp-idioma-altre" open={obert} onToggle={(e) => setObert(e.target.open)}>
        <summary>
          {teAltre
            ? t('multilingual.otherHas', { lang: nomAltre })
            : t('multilingual.otherAdd', { lang: nomAltre })}
        </summary>
        <textarea
          value={segur[altre] || ''}
          onChange={(e) => escriu(altre, e.target.value)}
          placeholder={placeholder[altre] || ''}
          rows={rows}
          maxLength={maxLength}
          className="camp-idioma-camp"
        />
        {maxLength && (
          <div className="char-count">{(segur[altre] || '').length}/{maxLength}</div>
        )}
      </details>
    </div>
  );
}

export default MultilingualTextArea;
